import * as React from "react";

import { Bar } from "@ant-design/plots";

const BarChart = ({ config, title, description = "" }) => {
  // console.log(config);
  return (
    <div className="p-2 rounded bg-gray-50">
      <div className="font-semibold text-sm text-gray-800 ">{title}</div>
      {description && (
        <div className=" text-xs text-gray-500 mb-2">{description}</div>
      )}
      <Bar {...config} />
    </div>
  );
};

export default BarChart;
